import { observable } from "mobx"
import store from "store"
import shop from "shop/shop"
import $fetch from "sdk/$fetch"

class Customer {
  constructor( data ) {
    Object.assign( this, data )
  }
}

class CustomerStore {
  @observable customers = []
  @observable byId = {}
  @observable currentId = false
  @observable restoreId = false
  
  constructor() {
    let id = sessionStorage.getItem( "iHandCustomer" )
    this.restoreId = id
  }
  
  setCustomer = async ( id, firstTime=false ) => {
    if ( !id ) throw Error( "Invalid Customer selected" )
    try {
      const response = await shop.fetch( `/shop/rest/handuser/selectcustomer?id=${id}` )
      const customer = store.get( `ihand-customer-${id}` )
      if ( customer && response.value ) {
        sessionStorage.setItem( "iHandCustomer", id )
        this.restoreId = id
        shop.session.setCustomer( customer )
        shop.cart.reset()
        shop.cart.get()
        await shop.whoami()
        firstTime &&  shop.toast( `<div>
<div>Kunde ausgewählt</div>
<div class="f6 ttu">${customer.title}, ${customer.pcode} ${customer.city}</div>
</div>` )
        this.currentId = id
        return response
      }
      return false
    } catch (err) {
      console.error( `Failure selecting customer ${id}`, err )
    }
  }
  
  /**
   *
   * @param count number of customers to return, default 500
   * @param start offset from the start, default 0
   * @returns {Promise<*>}
   */
  get = async ( { count = 500, start = 0 } = {} ) => {
    try {
      let response = await shop.fetch( `/shop/rest/data/customers?count=${count}&start=${start}` )
      this.customers = response.result.map( c => new Customer( c ) )
      this.customers.forEach( customer => {
        this.byId[ customer.map_id ] = customer
      } )
      return response.result
    } catch (err) {
      shop.toast( err, "warn", false, "bottom" )
    }
  }
}

const customerStore = new CustomerStore()
window.customerStore = customerStore

export default customerStore





// WEBPACK FOOTER //
// ./src/stores/customerStore.js